var _circle, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPrompt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 34,
    fill: "#0066CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9773 33.7813L55.2188 27.0227C54.9354 26.7371 54.5981 26.5106 54.2265 26.3565C53.8548 26.2024 53.4563 26.1237 53.0539 26.125H29.1875C28.3753 26.125 27.5963 26.4477 27.022 27.022C26.4477 27.5963 26.125 28.3753 26.125 29.1875V59.8125C26.125 60.6247 26.4477 61.4037 27.022 61.978C27.5963 62.5524 28.3753 62.875 29.1875 62.875H59.8125C60.6247 62.875 61.4037 62.5524 61.978 61.978C62.5523 61.4037 62.875 60.6247 62.875 59.8125V35.9461C62.8763 35.5437 62.7976 35.1452 62.6435 34.7735C62.4894 34.4019 62.2629 34.0646 61.9773 33.7813ZM52.1562 59.8125H36.8438V49.0938H52.1562V59.8125ZM59.8125 59.8125H55.2188V49.0938C55.2188 48.2815 54.8961 47.5026 54.3218 46.9283C53.7474 46.3539 52.9685 46.0313 52.1562 46.0313H36.8438C36.0315 46.0313 35.2526 46.3539 34.6782 46.9283C34.1039 47.5026 33.7812 48.2815 33.7812 49.0938V59.8125H29.1875V29.1875H53.0539L59.8125 35.9461V59.8125ZM50.625 33.7813C50.625 34.1874 50.4637 34.5769 50.1765 34.864C49.8893 35.1512 49.4999 35.3125 49.0938 35.3125H38.375C37.9689 35.3125 37.5794 35.1512 37.2922 34.864C37.0051 34.5769 36.8438 34.1874 36.8438 33.7813C36.8438 33.3752 37.0051 32.9857 37.2922 32.6985C37.5794 32.4113 37.9689 32.25 38.375 32.25H49.0938C49.4999 32.25 49.8893 32.4113 50.1765 32.6985C50.4637 32.9857 50.625 33.3752 50.625 33.7813Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 41,
    stroke: "#0066CC",
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPrompt);
export default __webpack_public_path__ + "static/media/EditPrompt.9c9cb55d7ac27761dc7d15d9eb67e87a.svg";
export { ForwardRef as ReactComponent };